<div id="graphCumul">
	<canvas id="graphConfigCumul">{{graphConfigCumul}}</canvas>
</div>